import React, { useRef, useState } from 'react';
import { PageContainer, FilterPod, TableComponents, ExportButton, Icons } from 'components';
import { useNavigate } from 'react-router-dom';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import { makeStyles } from '@mui/styles';
import { Grid, Button, Menu, MenuItem, Box } from '@mui/material';
import jMoment from 'moment-jalaali';
import { useExportFile , useCurrencyUnit } from 'hooks';
import LoanServices from '../services/LoanServices';
import { columns, generateData } from './components/Columns';
import LoanInstallmentDialog from './LoanInstallment';
import useCustomHook from '../hooks';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import axios from 'axios';
import {
  getExportLoanUrl,
} from 'URLs';
export default function LoanProvider() {
  // -- STATES --//
  const tableRef = useRef();
  const {
    loading,
    setLoading,
    filterParams,
    setFilterParams,
    size,
    setSize,
    filters,
    setFilters,
    selectedLoanId,
    openDialog,
    setOpenDialog,
    page, setPage
  } = useCustomHook();

  // --HOOKS--//

  const classes = useStyles();
  const { downloadFile, isExporting } = useExportFile({
    url: getExportLoanUrl(),
    filename: 'report-loan',
  });
  const currencyText = useCurrencyUnit();
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);
  /**
    * لیست اکشن ها رو برمیگرداند . به ازای هر اکشن ، درصورتیکه دسترسی داشته باشد ترو و دسترسی نداشته باشد فالز است
    */
  const actionsList =
    getDynamicObjectAction([
      'loanSaleListPage',
      'loanSaleListExportBtn',
      'loanSaleListDetailBtn',
    ]);
  // --API REQUESTS--//
  const getDicsountCodes = async (query) => {
    try {
      setLoading(true);
      const orderBy = [];

      const filter = toFilterVOS([...filters]);
      const queries = filterVOStoQueryStr(filter);

      jMoment.loadPersian({ usePersianDigits: false });

      const params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        startDate: '1396/01/01 00:00:00',
        endDate: jMoment(new Date().setHours(23, 59, 0, 0)).format('jYYYY/jMM/jDD 23:59:59'),
        ...queries,
      };

      const data = {
        filterVOS: filter ?? [],
        parentParams: [],
        orderByElementVOS: orderBy ?? [],
      };

      setFilterParams({ data, params });

      const res = await LoanServices.getLoanList(params);

      let list = [];
      if (res.result) {
        list = generateData(res.result, {
          page: query ? query?.pageNumber : page,
          pageSize: query?.pageSize || size,
        });
      }
      const d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      setLoading(false);
      return d; // passed to MaterialTable
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  const onExport = (type, index) => {
    const types = ['xls', 'csv'];
    downloadFile(types[index], filterParams?.data, filterParams?.params);
  };

  // -- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0)
    setSize(10)
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100)
  };

  const hint = 'در این بخش می‌توانید لیست تسهیلات اختصاص داده‌شده به دیگران را مشاهده کنید.';

  return (
    <PageContainer
      title="فروش اقساطی کسب‌وکار"
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.LOAN_LIST}
      className={classes.root}
    >
      <Grid item xs={12}>
        <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
          {actionsList['loanSaleListPage'] &&
            <FilterButton
              setOpenFilterDialog={setOpenFilterDialog}
              filters={filters}
            />
          }
          {actionsList['loanSaleListExportBtn'] &&
            <ExportButton
              loading={isExporting}
              types={['xls', 'csv']}
              onExport={onExport}
            />
          }
        </Box>
        <Box>
          <FilterPod
            filters={filters}
            onChange={onFiltersChange}
            openFilterDialog={openFilterDialog}
            setOpenFilterDialog={setOpenFilterDialog}
            handleCloseFilterDialog={handleCloseFilterDialog}
          />
        </Box>
      </Grid>
      {
       (actionsList['loanSaleListPage'] && currencyText) &&
        <TableComponents
          data={getDicsountCodes}
          columns={columns(SeeDetailBtn, actionsList , currencyText)}
          isLoading={loading}
          ref={tableRef}
          onChange={(ps) => {
            setPage(ps?.pageNumber)
            setSize(ps?.pageSize)
            return getDicsountCodes(ps)
          }}


        />
      }

      <LoanInstallmentDialog open={openDialog} setOpen={setOpenDialog} loanId={selectedLoanId} />
    </PageContainer>
  );
}

// See detail for every row
function SeeDetailBtn({ rd }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openDialog, setOpenDialog] = React.useState(false);
  const currencyText = useCurrencyUnit(false);
  const classes = useStyles();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event) => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();

  return (
    <div className={classes.otherActions}>
      <Button
        aria-controls="guild-other-actions"
        aria-haspopup="true"
        endIcon={<Icons icon="CaretDown" color="#343434" size="22" />}
        onClick={handleClick}
        variant="contained"
        className={classes.expandBtn}
      >
        عملیات
      </Button>
      <Menu
        className={classes.otherActionsMenu}
        id="guild-other-actions"
        keepMounted
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        elevation={2}
        onClose={handleClose}
      >
        <MenuItem
          className={classes.otherActionsMenuItem}
          onClick={() => {
            navigate(`/Loan/${rd.id}/details?isUser=false`);
          }}
        >
          جزییات قرارداد
        </MenuItem>
        <MenuItem
          className={classes.otherActionsMenuItem}
          onClick={() => {
            setOpenDialog(true);
            setAnchorEl(null);
          }}
        >
          مشاهده اقساط
        </MenuItem>
      </Menu>
      <LoanInstallmentDialog open={openDialog} setOpen={setOpenDialog} loanId={rd.id} currencyText={currencyText} />
    </div>
  );
}
const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTable-root': {
      border: 'solid 1px rgba(109, 114, 120, 0.18)',
      borderRadius: 4,
    },
    '& .MuiTableRow-head th:first-child': {
      borderTopLeftRadius: 4,
    },
    '& .MuiTableRow-head th:last-child': {
      borderTopRightRadius: 4,
      width: 145,
    },
  },
  props: {
    padding: theme.spacing(2, 3),
    boxSizing: 'border-box',
  },
  tickIcon: {
    color: '#43A047',
    fontSize: 17,
  },
  tickItem: {
    marginBottom: theme.spacing(1),
  },
  propsTitle: {
    color: '#2b3940',
    fontWeight: 'bold',
    fontSize: 12,
    marginBottom: theme.spacing(1.5),
  },
  tickText: {
    fontSize: 12,
    fontWeight: 'normal',
    marginInlineStart: theme.spacing(1),
    color: '#2b3940',
  },
  otherActions: {
    marginLeft: 'auto !important',
    marginRight: 'o !important',
  },
  otherActionsMenu: {
    border: '1px solid #d8d1d1',
  },
  otherActionsMenuItem: {
    padding: theme.spacing(1.5),
    color: 'gray',
    minWidth: 160,
    '&:hover': {
      color: theme.palette.info.main,
    },
  },
  expandBtn: {
    border: `1px solid #2b3990`,
    padding: theme.spacing(2),
    margin: 0,
    background: 'white',
    color: '#2b3990',
    '&:hover': {
      background: '#2b3990',
      color: '#fff',
      '& *': {
        stroke: '#fff'
      }
    }
  },
}));
